var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0147 30.1726C28.6575 38.3222 17.4378 35.5115 8.46275 26.5376C-0.512302 17.5637 -3.32181 6.34373 4.82778 0.985606C9.00204 -1.75863 10.6752 1.6679 12.0201 5.86073V5.86038C12.3795 6.9818 12.4231 8.18086 12.146 9.32553C11.8685 10.4702 11.2813 11.5162 10.4485 12.3486L9.66603 13.131C9.66603 13.131 8.90649 15.6485 14.127 20.8698C19.3469 26.091 21.8668 25.3347 21.8668 25.3347L22.6493 24.5523C23.4821 23.7194 24.528 23.1319 25.6727 22.8548C26.8174 22.5776 28.0161 22.6209 29.1375 22.9806C33.3325 24.323 36.7593 25.9988 34.0151 30.1729L34.0147 30.1726Z",
    fill: "black",
    fillOpacity: 0.29
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.907e569b3fe5c83087c1ed17e443538e.svg";
export { ForwardRef as ReactComponent };